import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ContinentType } from '../common-interfaces-classes/ContinentType';

@Injectable({
  providedIn: 'root'
})
export class ContinentHandlerService {

  private continentUpdateSubject = new Subject<ContinentType>();

  constructor() { }

  public get continentUpdateObservable() {
    return this.continentUpdateSubject.asObservable();
  }

  public emitContinentUpdate(continent: ContinentType) {
    this.continentUpdateSubject.next(continent);
  }
}
